'use client';

import quote from '../../../styles/modules/testimonials.module.scss';
import VadImage from "vadimages-nextjs-image-optimizer";
import {stripHtml} from "@/helpers/alt";
import SnapSlider from "@/components/SnapSlider/SnapSlider";

export type TestimonialsProps = {
    data: any;
    isHome?: boolean;
}

export default function Testimonials(props: TestimonialsProps) {
    let data = props.data;

    if(props.isHome) {
        data = data.filter((item: any) => item.authorImage !== 'testimonials/mike-sabatello.jpeg');
    }

    const imageFormat = [
        { name:'testimonials/jesse.webp', isRound: true, },
        { name:'testimonials/1.png', isRound: true, },
        { name:'testimonials/2.jpg', isRound: true, },
        { name:'testimonials/3.jpg', isRound: true, },
        { name:'testimonials/4.png', isRound: false, },
        { name:'testimonials/5.png', isRound: false, },
        { name:'testimonials/6.png', isRound: false, },
        { name:'testimonials/7.png', isRound: false, },
        { name:'testimonials/8.png', isRound: true, },
        { name:'testimonials/9.1.png', isRound: true, },
    ];

    // Stand-in for the CMS's brandLogo field, which does not exist yet: the
    // testimonials collection lives in the Payload backend rather than this repo.
    // Keyed by authorImage because that is the only stable id the row carries.
    // Vape-Jet, Maitri and Trade Roots have no mark in /images/brands yet.
    const brandLogos: Record<string, string> = {
        'testimonials/testimonial-tony.png': '/images/brands/blue-river.png',
        'testimonials/4.png': '/images/brands/copperstate.png',
        'testimonials/9.1.png': '/images/brands/new_logos/ayrloom.png',
        'testimonials/8.png': '/images/brands/verano.jpg',
        'testimonials/5.png': '/images/brands/friendly.png',
        'testimonials/1.png': '/images/brands/arcata-fire.png',
    };

    data = data.map((item: any) => {
        item.isRound = imageFormat.find((size: any) =>  size.name === item.authorImage)?.isRound;
        // Only the home page's frame draws the mark; other pages keep the plain
        // attribution they have today.
        item.brandLogo = props.isHome ? (item.brandLogo ?? brandLogos[item.authorImage] ?? null) : null;
        return item;
    });

    // Was a Swiper (slidesPerView 1, navigation + pagination); now a native CSS scroll-snap slider
    // with the same controls rebuilt without Swiper JS: side arrows (hidden on ipad-or-less by
    // testimonials.module.scss, as on live) and bullet pagination below.
    return (
        <div className={quote.testimonials__list}>
        <SnapSlider navigation pagination trackClassName="gap-0" itemClassName="w-full" snap="mandatory">
            {data && data.map((testimonial: {
                id: number,
                author: string,
                title: string,
                description: string,
                authorImage: string,
                isRound: boolean,
                brandLogo: string | null,
            }) => (
                <div className={`${quote.testimonials__list__item} ${ testimonial.isRound ? quote.testimonials__list__item__round : quote.testimonials__list__item__company}`} key={testimonial.id}>
                    <figure>
                        <VadImage src={'/images/' + testimonial.authorImage} alt={stripHtml(testimonial.author) || "Testimonial"} width={212} height={212} />
                    </figure>
                    <div>
                        <div className={quote.testimonials__list__item_author}>
                            {testimonial.brandLogo && (
                                <VadImage src={testimonial.brandLogo} alt="" width={55} height={47}
                                          className={quote.testimonials__list__item_brand} />
                            )}
                            <span dangerouslySetInnerHTML={{__html: testimonial.author}} />
                        </div>
                        <div className={quote.testimonials__list__item_title}>“{testimonial.title}”</div>
                        <div className={quote.testimonials__list__item_rte}><p>{testimonial.description}</p></div>
                    </div>
                </div>
            ))}
        </SnapSlider>
        </div>
    )
}
